import { Component } from "react";

import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";

import { OpenAPI } from "simplydo/interfaces";
import { GiphyGif } from "simplydo/react/components/Giphy/Gif";
import { useTheme } from "simplydo/react/theme";
import { Grid, Icon } from "simplydo/react/ui";

import FormattedComment from "components/lib/FormattedComment";

import type {
  FeedCardSharedProps,
  FeedCommentItem,
  FeedCommentMediaItem,
} from "../types";
import FeedCard from "./FeedCard";

type CardLeftProps = { comment: FeedCommentItem };

const CardLeft = ({ comment }: CardLeftProps) => {
  const hasComment = !!comment.comment;
  const hasMedia = comment.media?.length;
  const firstMediaItem: FeedCommentMediaItem =
    hasMedia && comment.media ? (comment.media[0] ?? {}) : {};
  const firstMediaItemIsImage =
    firstMediaItem.type === "gif" || firstMediaItem.type === "image";
  const firstMediaIsGif = firstMediaItem.type === "gif";
  const theme = useTheme();
  return (
    <Grid.Column
      stretched
      width={12}
      verticalAlign="middle"
      className="comment-column"
    >
      <div className="comment-column-container">
        <Icon
          style={{
            color: theme.primaryColour,
            marginRight: 15,
            fontSize: "3em",
          }}
          name="comment alternate"
          size="big"
        />
        {!hasComment && hasMedia && firstMediaItemIsImage ? (
          firstMediaIsGif ? (
            <GiphyGif gif={firstMediaItem.data} size="fixed" />
          ) : (
            <img
              style={{ borderRadius: 5, objectFit: "contain", maxHeight: 150 }}
              alt={firstMediaItem.value}
              src={firstMediaItem.signedDownloadRequest || firstMediaItem.value}
            />
          )
        ) : null}
        {hasComment ? (
          <p style={{ maxHeight: "100%" }}>
            <FormattedComment noLink>
              &quot;
              {comment.comment}
              &quot; &quot;
            </FormattedComment>
          </p>
        ) : null}
      </div>
    </Grid.Column>
  );
};

type CommentCardOwnProps = FeedCardSharedProps & {
  comment: FeedCommentItem;
  profileFeed?: boolean;
  profileUser?: OpenAPI.Schemas["PreparedUser"];
};

type CommentCardProps = CommentCardOwnProps & WithTranslation;

class CommentCard extends Component<CommentCardProps> {
  render() {
    const { comment, profileFeed, profileUser, hideAction, feedType } =
      this.props;
    return (
      <FeedCard
        user={comment.owner}
        action={
          profileFeed
            ? "activityFeed.comment.actionSomeone"
            : "activityFeed.comment.action"
        }
        feedType={feedType}
        subjectItem={profileFeed ? profileUser?.profile?.fullName : null}
        date={comment.createdAt}
        toLink={`/ideas/${comment.idea}`}
        type="COMMENT"
        cardContent={<CardLeft comment={comment} />}
        hideAction={hideAction}
      />
    );
  }
}

export default withTranslation()(CommentCard);
